import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Data} from '@angular/router';
import {MatDialog} from '@angular/material';
import { ErrorDialogComponent} from './dialog/error-dialog.component';
import {Profile} from '../profile.model';
import {UserService} from '../../shared/user/user.service';
import { ProfileService } from '../profile.service';
import { ProfileValidator } from '../profile.validators';



@Component({
  selector: 'app-edition',
  templateUrl: './edition.component.html',
  styleUrls: ['./edition.component.scss']
})
export class EditionComponent implements OnInit {
  profileLoading: boolean = false;
  form: FormGroup;
  formPwd: FormGroup;
  profile: Profile;
  pwdLoading: boolean = false;
  passwordNotSame: boolean = false;
  inputRequiredChange: boolean = false;
  hideOldPassword = true;
  hideNewPassword = true;
  hideConfirmPassword = true;

  constructor( private profileService: ProfileService,
               private fb: FormBuilder,
               public dialog: MatDialog,
               private userService: UserService,
               private route: ActivatedRoute,
               private profileValidator: ProfileValidator) {
    this.route.data.subscribe(
      (data: Data) => {
        this.profile = data['profile'];
      }
    );
  }

  ngOnInit() {

    this.form = this.fb.group ( {
      firstname: [
        null,
        Validators.compose([ Validators.required ])
      ],
      lastname: [
        null,
        Validators.compose([ Validators.required ])
      ],
      email: [
        null,
        Validators.compose([
          Validators.required, Validators.email]),
        Validators.composeAsync([])
      ],
      phone: [
        null,
        Validators.compose([ Validators.required ]),
        Validators.composeAsync([])
      ],
      username: [
        null,
        Validators.compose([ Validators.required ]),
        Validators.composeAsync([this.profileValidator.uniqueUsernmeValidator.bind(this.profileValidator)])
      ],
      picture: [
        null,
        Validators.compose([])
      ],
      timezoneOffset: [
        null,
        Validators.compose([Validators.required, this.profileValidator.timezoneOffsetValidator])
      ],
      address: [
        null,
        Validators.compose([ Validators.required ])
      ],
      callCenter: [
        null,
        Validators.compose([])
      ],
      reference: [
        null,
        Validators.compose([])
      ]
    });

    this.form.controls['firstname'].disable();
    this.form.controls['lastname'].disable();
    this.form.controls['phone'].disable();
    this.form.controls['username'].disable();

    this.form.patchValue(this.profile);

    this.formPwd = this.fb.group({
      oldPassword: [
        null,
        Validators.compose([Validators.required])
      ],
      plainPasswordFirst: [
        null,
        Validators.compose([
            Validators.required,
            Validators.minLength(8),
            ProfileValidator.differentFromField('oldPassword')
        ])
      ],
      plainPasswordSecond: [
        null,
        Validators.compose([Validators.required,
          this.profileValidator.confirmPassword ]),
        Validators.composeAsync([])
      ]
    });

    this.formPwd.controls['oldPassword'].valueChanges.subscribe(() => {
      this.formPwd.controls['plainPasswordFirst'].updateValueAndValidity({onlySelf: true});
    });

  }

  onPictureSelected(e) {
    this.form.controls['picture'].setValue(e);
    this.inputRequiredChange = true;
  }

  togglePasswordVisibility(field: 'old' | 'new' | 'confirm') {
    if (field === 'old') {
      this.hideOldPassword = !this.hideOldPassword;
    } else if (field === 'new') {
      this.hideNewPassword = !this.hideNewPassword;
    } else {
      this.hideConfirmPassword = !this.hideConfirmPassword;
    }
  }

  profileEdit() {
    this.profileLoading = true;
    const profile: Profile = this.form.value;
    this.profileService.putProfile(profile).subscribe(
      (response) => {
        const dialogRef = this.dialog.open(ErrorDialogComponent, {
          panelClass: 'custom-overlay-pane-class',
          hasBackdrop: true,
          backdropClass: '',
          width: '350px',
          height: '',
          position: {
            top: '',
            bottom: '',
            left: '',
            right: ''
          },
          data: {
            message: 'YOUR PROFILE IS SUCCESSFULLY UPDATED',
            messageType: 'SUCCESS',
            button: 'OK'
          },
        });
        dialogRef.afterClosed().subscribe(result => {
          this.inputRequiredChange = false;
          this.profileLoading = false;
        });
      },
      (error) => {
        this.profileLoading = false;
        const dialogRef = this.dialog.open(ErrorDialogComponent, {
          panelClass: 'custom-overlay-pane-class',
          hasBackdrop: true,
          backdropClass: '',
          width: '50%',
          height: '',
          position: {
            top: '',
            bottom: '',
            left: '',
            right: ''
          },
          data: { message: error.error.message, messageType: 'ERROR', button: 'CANCEL' },
        });
      }
    );
  }

  passwordEdit() {
    this.pwdLoading = true;
    const pwd = {
      'oldPassword': this.formPwd.value.oldPassword,
      'plainPassword': {
        'first': this.formPwd.value.plainPasswordFirst,
        'second': this.formPwd.value.plainPasswordSecond
      }
    };
    this.profileService.putPassword(pwd).subscribe(
      (response) => {
        this.formPwd.reset();
        const dialogRef = this.dialog.open(ErrorDialogComponent, {
          panelClass: 'custom-overlay-pane-class',
          hasBackdrop: true,
          backdropClass: '',
          width: '350px',
          height: '',
          position: {
            top: '',
            bottom: '',
            left: '',
            right: ''
          },
          data: {
            message: 'YOUR PASSWORD IS SUCCESSFULLY MODIFIED, YOU WILL BE DISCONNECTED',
            messageType: 'SUCCESS',
            button: 'OK'
          },
        });
        dialogRef.afterClosed().subscribe(result => {
          this.userService.currentUser.next(null);
          this.pwdLoading = false;
        });
      },
      (error) => {
        this.pwdLoading = false;
        let errorMsg = '';
        let errorFormatted = error.error.errors;
        if (errorFormatted.children) {
          if (errorFormatted.children.oldPassword.errors) {
            errorMsg += errorFormatted.children.oldPassword.errors[0];
          }else if (errorFormatted.plainPassword.children.first.errors) {
            errorMsg += errorFormatted.plainPassword.children.first.errors[0];
          }
          const dialogRef = this.dialog.open(ErrorDialogComponent, {
            panelClass: 'custom-overlay-pane-class',
            hasBackdrop: true,
            backdropClass: '',
            width: '50%',
            height: '',
            position: {
              top: '',
              bottom: '',
              left: '',
              right: ''
            },
            data: { message: errorMsg, messageType: 'ERROR', button: 'CANCEL' },
          });
        }
      }
    );
  }
  onTap(e) {
    if (e) {
      this.inputRequiredChange = true;
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/profile/edition/edition.component.ts